// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';
import { getTheme } from 'settings/theme';

const { palette } = getTheme();
const PromptModalWrapper: StatelessFunctionalComponent<any> = styled.div`
  background-color: ${palette.greyscale.white};
  border-radius: 0.8rem;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 3rem;

  .prompt-modal {
    &__buttons-container {
      display: flex;
      justify-content: space-around;
      width: 100%;
    }

    &__title,
    &__subtitle {
      margin-bottom: 4rem;
    }
  }
`;
export default PromptModalWrapper;
